export default "/backend/static/media/modify_organization3.c7d0e496.png";